<template>
  <div>
    <b-row>
      <b-col cols="12">
        <brands-filter :get-report-data="getBrands" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <b-row>
          <b-col cols="12">
            <primary-heading
              title-text="Genel Toplam"
            />
          </b-col>
          <b-col
            cols="12"
          >
            <b-row>
              <b-col
                cols="12"
                md="4"
              >
                <default-card
                  title="Satışlar"
                  :value="brands.grandTotal.sales"
                  icon="CheckCircleIcon"
                  color="success"
                />
                <pie-charts
                  :series-data="brands.grandTotal.salesChart.series"
                  :categories-data="brands.grandTotal.salesChart.categories"
                  :colors-data="brands.grandTotal.salesChart.colors"
                  chart-type="donut"
                  chart-title="Marka Bazlı Satışlar"
                  :legend-show="false"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
              >
                <default-card
                  title="Bağlantılar"
                  :value="brands.grandTotal.connections"
                  icon="LinkIcon"
                  color="info"
                />
                <pie-charts
                  :series-data="brands.grandTotal.connectionsChart.series"
                  :categories-data="brands.grandTotal.connectionsChart.categories"
                  :colors-data="brands.grandTotal.connectionsChart.colors"
                  chart-type="donut"
                  chart-title="Marka Bazlı Bağlantılar"
                  :legend-show="false"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
              >
                <default-card
                  title="Stoklar"
                  :value="brands.grandTotal.stocks"
                  icon="CodesandboxIcon"
                  color="warning"
                />
                <pie-charts
                  :series-data="brands.grandTotal.stocksChart.series"
                  :categories-data="brands.grandTotal.stocksChart.categories"
                  :colors-data="brands.grandTotal.stocksChart.colors"
                  chart-type="donut"
                  chart-title="Marka Bazlı Stoklar"
                  :legend-show="false"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-card no-body>
              <b-card-header class="border-bottom">
                <b-card-title>Marka Bazlı Adetler</b-card-title>
                <b-form-checkbox
                  v-model="isTable"
                  switch
                >
                  Tablo Görünümü
                </b-form-checkbox>
              </b-card-header>
              <list-table
                v-if="isTable"
                :data-list="brands.data"
                :grand-totals="brands.grandTotal"
              />
              <list-cards
                v-else
                :data-list="brands.data"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue'
import BrandsFilter from '@/views/I2Sales/FilterCards/BrandsFilter.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'
import ListCards from '@/views/I2Sales/Brands/ListCards.vue'
import ListTable from '@/views/I2Sales/Brands/ListTable.vue'

export default {
  name: 'I2Sales',
  components: {
    LoadingCard,
    BrandsFilter,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    DefaultCard,
    PrimaryHeading,
    PieCharts,
    ListCards,
    ListTable,
  },
  data() {
    return {
      isTable: false,
    }
  },
  computed: {
    loading() {
      return this.$store.getters['i2SalesReports/loading']
    },
    brands() {
      return this.$store.getters['i2SalesReports/brands']
    },
    brandsParams() {
      return this.$store.getters['i2SalesReports/brandsParams']
    },
  },
  created() {
    this.getBrands()
  },
  methods: {
    getBrands() {
      this.$store.dispatch('i2SalesReports/getBrands', this.brandsParams)
    },
  },
}
</script>
